document.addEventListener("DOMContentLoaded", function () {
    function containsThai(text) {
        const thaiPattern = /[\u0E00-\u0E7F]/; // Unicode range for Thai script
        return thaiPattern.test(text);
    }

    function applyThaiFont() {
        document.querySelectorAll("body *:not(script):not(style)").forEach(element => {
            if (containsThai(element.innerText)) {
                element.classList.add("thai-text"); // Add class to Thai text elements
            }
        });
    }

    applyThaiFont();
});